/* eslint-disable no-control-regex */

import { ColumnSettings, ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

import { CreateColumnValue } from '@/shared/fx-parser'

/**
 * helpers to format settings value before sending it to SDK.
 * used in create/update column settings
 */
export function formatColumnSettings(settings: CreateColumnValue) {
  return getColumnSettingsValue(settings.type, settings) as ColumnSettings
}

export function getColumnSettingsValue(type: ColumnTypes, settings: any): ColumnSettings {
  function spreadValueIfExist(key: keyof CreateColumnValue) {
    if (key in settings) {
      return { ...settings[key] }
    }
    return { ...settings }
  }

  switch (type) {
    case ColumnTypes.Icon:
      return spreadValueIfExist('icOptions')
    case ColumnTypes.Number:
      return spreadValueIfExist('numberOptions')
    case ColumnTypes.DateTime:
      return spreadValueIfExist('dtOptions')
    case ColumnTypes.Phone:
      return spreadValueIfExist('phoneOptions')
    case ColumnTypes.Address:
      return spreadValueIfExist('addressOptions')
    case ColumnTypes.Image:
      return spreadValueIfExist('imageOptions')
    case ColumnTypes.Rating:
      return spreadValueIfExist('ratingOptions')
    case ColumnTypes.Slug:
      return spreadValueIfExist('slugOptions')
    case ColumnTypes.AISEO:
      return spreadValueIfExist('seoAiOptions')
    case ColumnTypes.AITextProcessing:
      return spreadValueIfExist('textProcOptions')
    case ColumnTypes.QRCode:
      return spreadValueIfExist('qrOptions')
    case ColumnTypes.Barcode:
      return spreadValueIfExist('barcodeOptions')
    case ColumnTypes.Color:
      return spreadValueIfExist('colorOptions')
    case ColumnTypes.Join:
      return spreadValueIfExist('joinOptions')
    case ColumnTypes.Formula:
      return spreadValueIfExist('formulaOptions')
    case ColumnTypes.Function:
      return { ...settings }
    case ColumnTypes.Math:
      return {
        ...spreadValueIfExist('mathOptions'),
        ...spreadValueIfExist('numberOptions'),
      }
    case ColumnTypes.Template:
      const escapeOpeningCurlyBraces = (str: string) => {
        if (!str) return str

        const placeholders: string[] = []

        const protectedStr = str.replace(/{{[\s\S]*?}}/g, (m) => {
          placeholders.push(m)
          return `\u0000${placeholders.length - 1}\u0000` // sentinel
        })

        const escaped = protectedStr.replace(/(?<!\\)\{+/g, (m) => '\\' + m)

        return escaped.replace(/\u0000(\d+)\u0000/g, (_, i) => placeholders[+i])
      }

      const transformedTemplate = settings?.templateOptions

      if ('tmpl' in transformedTemplate) {
        transformedTemplate.tmpl = escapeOpeningCurlyBraces(transformedTemplate.tmpl)
      }

      const newData = {
        ...spreadValueIfExist('templateOptions'),
        ...transformedTemplate,
      }

      return newData

    case ColumnTypes.SingleCell:
      return { ...spreadValueIfExist('singleCellOptions') }
    case ColumnTypes.Lookup:
      return { ...spreadValueIfExist('lookupOptions') }
    default:
      return {}
  }
}
